module.exports = __webpack_public_path__ + "static/img/logo_nav.a866c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_nav.png
// module id = rFvK
// module chunks = 8